import { StoreState } from "../RootReducer";
import * as UserSelectors from "../User/User.selector";

import * as UserUtils from "../../lib/util/UserUtils";

export const selectCompetitions = (state: StoreState) =>
	state.Rewards.competitions || {};

export const selectRewardsEnabled = (state: StoreState) => {
	const fleetId = UserSelectors.selectCurrentScopeFleetId(state);
	const loggedInUser = UserSelectors.selectLoggedInUser(state);
	const rewardsEnabled = UserUtils.isRewardsEnabled(loggedInUser);

	if (!rewardsEnabled || !fleetId || !state.Rewards.competitions.value) {
		return false;
	}

	return Object.values(state.Rewards.competitions.value).some(
		(competition) =>
			competition.typeId === "RAFFLE" && competition.fleetId === fleetId,
	);
};
